<template>
    <div class="navbar">
        <div class="navbar-brand">
            <router-link to="/" class="navbar-item"><i class="fa fa-home"></i></router-link>
            <a class="navbar-burger burger"
               :class="{ 'is-active': isActive }"
               v-on:click="toggleNav"
            >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div class="navbar-menu"
             :class="{ 'is-active': isActive }"
        >
            <div class="navbar-end">
                <router-link
                    v-for="route in getRoutes"
                    :key="route.id"
                    :to="route.path"
                    class="navbar-item"
                >
                {{ $t(route.name) }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        toggleNav() {
            this.isActive = !this.isActive;
        }
    },
    computed: {
        getRoutes() {
            const excluded = ['not-found', 'home', 'apps'];
            return this.$router.options.routes.filter(i => !excluded.includes(i.name));
        }
    },
    data() {
        return {
            isActive: false
        }
    }
}
</script>

<style lang="scss" scoped>
.navbar-burger {
    color: #fff;
}
a:focus {
    color: #000 !important;
}
</style>

<i18n>
{
    "en": {
        "projects": "Projects",
        "contact": "Contact",
        "experience": "Experience"
    },
    "fi": {
        "projects": "Projektit",
        "contact": "Yhteystiedot",
        "experience": "Kokemus"
    }
}
</i18n>
